import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'
import useResetState from 'hooks/useResetState'
import CheckRowCount from 'components/forms/CheckRowCount'

export const CountFilter = ({
  filterValues,
  counts,
  getLabel = name => name,
  getRowLabel,
  onChange,
  clear,
  create,
  selectProps = {}
}) => {
  const [selectedValues, setSelectedValues] = useResetState(filterValues, clear)

  const handleToggle = name => {
    const optionsList = !selectedValues.includes(name)
      ? [...(selectedValues || []), name]
      : [...(selectedValues || []).filter(itemName => itemName !== name)]
    setSelectedValues(optionsList)
    onChange(optionsList)
  }

  const handleMultiSelect = (options = []) => {
    const optionsList = options?.map(({ value }) => value) || []
    setSelectedValues(optionsList)
    onChange(optionsList)
  }
  const SelectComponent = create ? CreatableSelect : Select
  return (
    <div>
      <SelectComponent
        options={counts.map(({ key, docCount }) => ({ label: `${getLabel(key)} (${docCount.toLocaleString()})`, value: key }))}
        onChange={handleMultiSelect}
        value={counts
          .filter(({ key, docCount }) => selectedValues.includes(key))
          .map(({ key, docCount }) => ({
            label: `${getLabel(key)} (${docCount})`,
            value: key
          }))}
        styles={{
          multiValue: (provided, state) => ({
            ...provided,
            maxWidth: '10rem'
          })
        }}
        isMulti
        formatCreateLabel={(inputValue) => `Search "${inputValue}"`}
        {...selectProps}
      />
      {counts.slice(0, 4).map(({ key, docCount }) => (
        <CheckRowCount
          key={key}
          text={getRowLabel ? getRowLabel(key) : getLabel(key)}
          count={docCount}
          checked={selectedValues.includes(key)}
          toggle={() => handleToggle(key)}
        />
      ))}
    </div>
  )
}

export default CountFilter
